import { render, staticRenderFns } from "./NewChannel.vue?vue&type=template&id=0f67d32f&scoped=true"
import script from "./NewChannel.vue?vue&type=script&lang=js"
export * from "./NewChannel.vue?vue&type=script&lang=js"
import style0 from "./NewChannel.vue?vue&type=style&index=0&id=0f67d32f&prod&lang=scss&scoped=true"
import style1 from "./NewChannel.vue?vue&type=style&index=1&id=0f67d32f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f67d32f",
  null
  
)

export default component.exports